// extracted by mini-css-extract-plugin
export default {"section":"GalleryFolder_section__mRxA3","thumbnails":"GalleryFolder_thumbnails__rudij","thumbnail":"GalleryFolder_thumbnail__PkWoV","description":"GalleryFolder_description__r6+Xu"};